module.exports = __webpack_public_path__ + "static/media/Fillet.af448bb6.jpeg";